import { Loader } from '@googlemaps/js-api-loader';

let loaderInstance: Loader | null = null;
let placesLibraryPromise: Promise<google.maps.PlacesLibrary> | null = null;

function getLoader(): Loader {
  if (!loaderInstance) {
    loaderInstance = new Loader({
      apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
      version: 'weekly',
    });
  }
  return loaderInstance;
}

export const loadGoogleMapsScript = (): Promise<void> => {
  return getLoader().load().then(() => undefined);
};

// Load the Places library using the new importLibrary API
export const getPlacesLibrary = async (): Promise<google.maps.PlacesLibrary> => {
  if (placesLibraryPromise) {
    return placesLibraryPromise;
  }

  // Ensure the core script is loaded first
  await loadGoogleMapsScript();

  placesLibraryPromise = google.maps.importLibrary('places') as Promise<google.maps.PlacesLibrary>;

  return placesLibraryPromise;
};
